export default "__VITE_ASSET__BkhjTfPk__"